(function() {
    "use strict";
    window.sunClipConfiguratorData = {
        lensColors: {
            solid: [ {
                id: "Solid-Grey",
                name: "Grey",
                hex: "#808080",
                description: "Classic grey tint for everyday wear"
            }, {
                id: "Solid-G15",
                name: "G-15",
                hex: "#4a5d4a",
                description: "Green-grey military specification lens"
            }, {
                id: "Solid-Brown",
                name: "Brown",
                hex: "#654321",
                description: "Warm brown for enhanced contrast"
            }, {
                id: "Solid-Amber",
                name: "Amber",
                hex: "#ffbf00",
                description: "Bright amber for low-light conditions"
            }, {
                id: "Solid-Bronze",
                name: "Bronze",
                hex: "#cd7f32",
                description: "Rich bronze for warm tones"
            }, {
                id: "Solid-Yellow",
                name: "Yellow",
                hex: "#ffff00",
                description: "High contrast yellow for sports"
            }, {
                id: "Solid-Rose",
                name: "Rose",
                hex: "#ff007f",
                description: "Soothing rose tint"
            }, {
                id: "Solid-Blue",
                name: "Blue",
                hex: "#0080ff",
                description: "Cool blue for bright conditions"
            } ],
            mirror: [ {
                id: "Mirror-Morado",
                name: "Morado",
                hex: "#800080",
                description: "Purple mirror coating with style",
                mirror: true
            }, {
                id: "Mirror-Green",
                name: "Green",
                hex: "#00ff00",
                description: "Vibrant green mirror finish",
                mirror: true
            }, {
                id: "Mirror-Orange",
                name: "Orange",
                hex: "#ffa500",
                description: "Bold orange mirror coating",
                mirror: true
            }, {
                id: "Mirror-SkyBlue",
                name: "Sky Blue",
                hex: "#87ceeb",
                description: "Light blue mirror for sunny days",
                mirror: true
            }, {
                id: "Mirror-Gold",
                name: "Gold",
                hex: "#ffd700",
                description: "Luxurious gold mirror finish",
                mirror: true
            }, {
                id: "Mirror-Silver",
                name: "Silver",
                hex: "#c0c0c0",
                description: "Sleek silver mirror coating",
                mirror: true
            }, {
                id: "Mirror-Blue",
                name: "Blue",
                hex: "#0000ff",
                description: "Deep blue mirror finish",
                mirror: true
            }, {
                id: "Mirror-Caliente",
                name: "Caliente",
                hex: "#ff4500",
                description: "Hot red-orange mirror coating",
                mirror: true
            } ],
            gradient: [ {
                id: "Gradient-Amber",
                name: "Amber Gradient",
                gradient: [ "#ffbf00", "#ffffff" ],
                description: "Amber fade to clear"
            }, {
                id: "Gradient-VioletRose",
                name: "Violet Rose Gradient",
                gradient: [ "#8b008b", "#ff69b4" ],
                description: "Purple to pink gradient"
            }, {
                id: "Gradient-DarkBrown",
                name: "Dark Brown Gradient",
                gradient: [ "#3b2414", "#ffffff" ],
                description: "Dark brown fade"
            }, {
                id: "Gradient-Rouge",
                name: "Rouge Gradient",
                gradient: [ "#a94064", "#ffffff" ],
                description: "Rouge red gradient"
            }, {
                id: "Gradient-DarkGrey",
                name: "Dark Grey Gradient",
                gradient: [ "#2f4f4f", "#ffffff" ],
                description: "Dark grey to clear"
            }, {
                id: "Gradient-VioletGrey",
                name: "Violet Grey Gradient",
                gradient: [ "#8b008b", "#808080" ],
                description: "Violet to grey blend"
            }, {
                id: "Gradient-CrimsonGrey",
                name: "Crimson Grey Gradient",
                gradient: [ "#dc143c", "#808080" ],
                description: "Crimson to grey fade"
            }, {
                id: "Gradient-MediumBrown",
                name: "Medium Brown Gradient",
                gradient: [ "#8b4513", "#ffffff" ],
                description: "Medium brown gradient"
            } ]
        },
        bridgeColors: [ {
            id: "Gold",
            name: "Gold",
            hex: "#ffd700"
        }, {
            id: "Silver",
            name: "Silver",
            hex: "#c0c0c0"
        }, {
            id: "Gunmetal",
            name: "Gunmetal",
            hex: "#2a3439"
        }, {
            id: "Bronze",
            name: "Bronze",
            hex: "#cd7f32"
        }, {
            id: "MatteBlack",
            name: "Matte Black",
            hex: "#28282b"
        } ],
        magnetColors: [ {
            id: "Gold",
            name: "Gold",
            hex: "#ffd700"
        }, {
            id: "Gunmetal",
            name: "Gunmetal",
            hex: "#2a3439"
        }, {
            id: "Silver",
            name: "Silver",
            hex: "#c0c0c0"
        } ],
        crystalColors: [ {
            id: "none",
            name: "No Crystal",
            hex: null,
            price: 0
        }, {
            id: "Diamond",
            name: "Diamond",
            hex: "#b9f2ff",
            price: 25
        }, {
            id: "Gold",
            name: "Gold Crystal",
            hex: "#ffd700",
            price: 25
        }, {
            id: "Cobalt",
            name: "Cobalt",
            hex: "#0047ab",
            price: 25
        }, {
            id: "Aquamarine",
            name: "Aquamarine",
            hex: "#7fffd4",
            price: 25
        }, {
            id: "Ametthyst",
            name: "Amethyst",
            hex: "#9966cc",
            price: 25
        }, {
            id: "Rose",
            name: "Rose",
            hex: "#ff007f",
            price: 25
        }, {
            id: "Hyacinth",
            name: "Hyacinth",
            hex: "#7b68ee",
            price: 25
        }, {
            id: "Fireopal",
            name: "Fire Opal",
            hex: "#ff5733",
            price: 25
        }, {
            id: "Topaz",
            name: "Topaz",
            hex: "#ffc87c",
            price: 25
        }, {
            id: "Emerald",
            name: "Emerald",
            hex: "#50c878",
            price: 25
        }, {
            id: "Olivine",
            name: "Olivine",
            hex: "#9ab973",
            price: 25
        }, {
            id: "Hematite",
            name: "Hematite",
            hex: "#383838",
            price: 25
        } ],
        pricing: {
            base: 149,
            lensUpgrades: {
                solid: 0,
                mirror: 20,
                gradient: 15
            },
            crystalBase: 25
        },
        frames: {
            "Raen-Angle": {
                name: "Raen Angle",
                views: [ "front", "angle", "side" ],
                defaultView: "angle"
            }
        },
        getImagePath: function(frameModel, type, color, view) {
            view = view || "Angle";
            let fileName = "";
            if (type.toLowerCase() === "frame") {
                fileName = frameModel + "-Frame.png";
            } else if (type.toLowerCase() === "lens") {
                fileName = frameModel + "-Lens-" + color + ".png";
            } else if (type.toLowerCase() === "bridge") {
                fileName = frameModel + "-Bridge-" + color + ".png";
            } else if (type.toLowerCase() === "magnet") {
                if (color === "Gold" || color === "Gunmetal") {
                    fileName = frameModel + "-Magnets-" + color + ".png";
                } else {
                    fileName = frameModel + "-Magnet-" + color + ".png";
                }
            } else if (type.toLowerCase() === "crystal") {
                fileName = frameModel + "-Crystal-" + color + ".png";
            }
            return fileName;
        },
        getAssetUrl: function(fileName) {
            return fileName;
        },
        getColorById: function(colorId, category) {
            if (category && this.lensColors[category]) {
                return this.lensColors[category].find(color => color.id === colorId);
            }
            for (let cat in this.lensColors) {
                const color = this.lensColors[cat].find(color => color.id === colorId);
                if (color) return color;
            }
            return null;
        },
        getBridgeById: function(colorId) {
            return this.bridgeColors.find(color => color.id === colorId);
        },
        getMagnetById: function(colorId) {
            return this.magnetColors.find(color => color.id === colorId);
        },
        getCrystalById: function(colorId) {
            return this.crystalColors.find(crystal => crystal.id === colorId);
        }
    };
    window.configuratorData = window.sunClipConfiguratorData;
    window.ConfiguratorData = window.sunClipConfiguratorData;
})();